function AdminConfigurationController(analysisService, userService, userViewService, toasterService) {
    const ctrl = this;

    ctrl.$onInit = () => {
        userViewService.setView('admin-configuration');
        ctrl.hasAccessUpdateConfigurations = userService.hasAccessUpdateConfigurations();
        ctrl.eventInfoVersion = undefined;
        ctrl.descriptorModulesVersion = undefined;
        ctrl.signalsVersion = undefined;

        ctrl.refreshEventInfoVersionNumber();
        ctrl.refreshDescriptorModulesVersionNumber();
        ctrl.refreshSignalsVersionNumber();
    };

    ctrl.refreshEventInfoVersionNumber = () => {
        analysisService.eventInfoVersion()
            .then(json => ctrl.eventInfoVersion = json.version);
    };

    ctrl.refreshDescriptorModulesVersionNumber = () => {
        analysisService.descriptorModulesVersion()
            .then(json => ctrl.descriptorModulesVersion = json.version);
    };

    ctrl.refreshSignalsVersionNumber = () => {
        analysisService.signalsVersion()
            .then(json => ctrl.signalsVersion = json.version);
    };

    ctrl.eventFileSelected = (event, files) => {
        if (!files || files.length === 0) return;
        ctrl.onFileUpload(files[0], ctrl.onEventInfoUpload, ctrl.refreshEventInfoVersionNumber);

    };

    ctrl.descriptorFileSelected = (event, files) => {
        if (!files || files.length === 0) return;
        ctrl.onFileUpload(files[0], ctrl.onVersionDescriptorUpload, ctrl.refreshDescriptorModulesVersionNumber);
    };

    ctrl.signalsFileSelected = (event, files) => {
        if (!files || files.length === 0) return;
        ctrl.onFileUpload(files[0], ctrl.onSignalsUpload, ctrl.refreshSignalsVersionNumber);
    };

    ctrl.onFileUpload = async (file, uploadFunction, refreshFunction) => {
        const response = await uploadFunction(file);
        ctrl.handleUploadResponse(response, refreshFunction);
    };

    ctrl.onEventInfoUpload = async (file) => {
        return await analysisService.uploadEventInfo(file);
    };

    ctrl.onVersionDescriptorUpload = async (file) => {
        return await analysisService.uploadDescriptorModules(file);
    };

    ctrl.onSignalsUpload = async (file) => {
        return await analysisService.uploadSignals(file);
    };

    ctrl.handleUploadResponse = (response, refreshFunction) => {
        if (response.statusCode === 200) {
            toasterService.success('toaster.file-upload-success');
            refreshFunction();
        } else if (response.statusCode === 422) {
            toasterService.error('File upload error', 'File could not be parsed');
        } else if (response.headers.error) {
            let errorObj = JSON.parse(response.headers.error);
            if (errorObj) toasterService.error('File upload error', _.values(errorObj)[0]);
        } else {
            toasterService.error('File upload error', 'Failed to upload, check that the version is newer');
        }
    };
}

angular
    .module('admin-configuration.module')
    .controller('AdminConfigurationController', AdminConfigurationController);